import {DataItem} from 'vis-timeline/esnext';
import moment from 'moment';
import {DataTransformerInterface} from '@/interfaces/data-transformer.interface';
import {MechanicBookingType} from '@/views/timeline/services/booking.types';
import {TIMELINE_HTML_UTILS_INSTANCE} from '@/views/timeline/services/timeline-html.utils';

class MechanicBookingToVisDataItemTransformer implements DataTransformerInterface<MechanicBookingType, DataItem> {

    transform(input: MechanicBookingType): DataItem {
        return {
            id: input.id,
            content: this.defineContent(input),
            start: input.start,
            end: input.end,
            style: 'background-color: ' + input.color,
            title: this.defineTitle(input),
            className: TIMELINE_HTML_UTILS_INSTANCE.getTimelineItemClass('mechanics', 'text-center'),
            group: input.mechanicId
        };
    }

    protected defineTitle(input: MechanicBookingType) {
        return 'Klicken für weitere Details';
    }

    protected defineContent(input: MechanicBookingType) {
        let content = '';
        const restTime = TIMELINE_HTML_UTILS_INSTANCE.createTimelineItemTooltipPair(
            'Restzeit:',
            input.mechanicRestAvailability.hours() + ' Stunde(n)'
        );
        content += TIMELINE_HTML_UTILS_INSTANCE.createTimelineItemTooltipPairsWrapper(restTime, 'subtitle-2');

        for (const schedule of input.schedules) {
            let scheduleInfo = '';
            const start = moment(schedule.start as Date).format('HH:mm');
            const end = moment(schedule.end as Date).format('HH:mm');

            scheduleInfo += TIMELINE_HTML_UTILS_INSTANCE.createTimelineItemTooltipPair(
                'Uhrzeit:', start + '-' + end
            );

            scheduleInfo += TIMELINE_HTML_UTILS_INSTANCE.createTimelineItemTooltipPairMultiline(
                'Tätigkeit:', String(schedule.title)
            );

            const rawContent: any = schedule.raw?.event;
            if (rawContent) {
                scheduleInfo += TIMELINE_HTML_UTILS_INSTANCE.createTimelineItemTooltipPair(
                    'Kunde:', rawContent.customer
                );

                scheduleInfo += TIMELINE_HTML_UTILS_INSTANCE.createTimelineItemTooltipPairMultiline(
                    'Baustelle:', rawContent.location
                );
            }

            content += TIMELINE_HTML_UTILS_INSTANCE.createTimelineItemTooltipPairsWrapper(scheduleInfo);
        }

        return content;
    }

}

const MECHANIC_BOOKING_TO_VIS_DATA_ITEM_TRANSFORMER_INSTANCE =
    new MechanicBookingToVisDataItemTransformer();

export {MECHANIC_BOOKING_TO_VIS_DATA_ITEM_TRANSFORMER_INSTANCE, MechanicBookingToVisDataItemTransformer};
